import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from "react";
import AiTagItem from "./AiTagItem";
import DropdownMenu from "../common/DropdownMenu";
import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import classNames from "classnames";
var AddBulkTagging = function AddBulkTagging(_ref) {
  var _assigneeField$proper;
  var result = _ref.result,
    customFields = _ref.customFields,
    saveAllTags = _ref.saveAllTags,
    setFieldSelections = _ref.setFieldSelections,
    onSelectAssignee = _ref.onSelectAssignee;
  var _useState = useState(null),
    editingTag = _useState[0],
    setEditingTag = _useState[1];
  var lastAssitantMessageId = useStoreState(Store, function (s) {
    return s.lastAssitantMessageId;
  });
  var _useState2 = useState(lastAssitantMessageId !== (result === null || result === void 0 ? void 0 : result.assistantIdentifier)),
    isDisabled = _useState2[0],
    setIsDisabled = _useState2[1];
  var _useState3 = useState(result === null || result === void 0 ? void 0 : result.fieldSelections),
    fieldSelections = _useState3[0],
    _setFieldSelections = _useState3[1];
  useEffect(function () {
    setIsDisabled(lastAssitantMessageId !== (result === null || result === void 0 ? void 0 : result.assistantIdentifier));
  }, [lastAssitantMessageId, result === null || result === void 0 ? void 0 : result.assistantIdentifier]);
  var _onEdit = function onEdit(tag) {
    setEditingTag(tag);
    setEditedValue(tag.value);
  };
  var _onSave = function onSave(tag) {
    if (editedValue) {
      setFieldSelections(fieldSelections.map(function (t) {
        return t.field.id === tag.field.id ? _objectSpread(_objectSpread({}, t), {}, {
          value: editedValue
        }) : t;
      }));
      _setFieldSelections(fieldSelections.map(function (t) {
        return t.field.id === tag.field.id ? _objectSpread(_objectSpread({}, t), {}, {
          value: editedValue
        }) : t;
      }));
    }
    setEditingTag(null);
  };
  var _onCancel = function onCancel(tag) {
    setEditingTag(null);
  };
  var _onRemove = function onRemove(tag) {
    _setFieldSelections(fieldSelections.filter(function (t) {
      return t.field.uuid !== tag.field.uuid;
    }));
    setFieldSelections(fieldSelections.filter(function (t) {
      return t.field.uuid !== tag.field.uuid;
    }));
  };
  var _useState4 = useState(null),
    editedValue = _useState4[0],
    setEditedValue = _useState4[1];
  var _onValueChange = function onValueChange(tag, value) {
    setEditedValue(value);
  };
  var isAssigneeField = function isAssigneeField(field) {
    return field.tag_type === "user" && field.tag === "Assignee" && field.additional.isSystemField === true;
  };
  var assigneeField = customFields.find(isAssigneeField);
  var assigneeOptions = (assigneeField === null || assigneeField === void 0 || (_assigneeField$proper = assigneeField.properties) === null || _assigneeField$proper === void 0 ? void 0 : _assigneeField$proper.options) || [];
  var _useState5 = useState(result === null || result === void 0 ? void 0 : result.assignee),
    assignee = _useState5[0],
    setAssignee = _useState5[1];
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("dark:text-gray-200 w-full", {
      "pointer-events-none opacity-50": isDisabled
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-[80%] max-w-xl border border-gray-300 dark:border-gray-800 rounded-xl shadow-sm dark:bg-gray-800 bg-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-100 dark:bg-gray-700 px-5 py-3 rounded-t-xl border-b border-gray-300 dark:border-gray-700"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-lg font-semibold text-gray-800 dark:text-gray-100"
  }, "Bulk Tagging")), assignee && /*#__PURE__*/React.createElement("div", {
    className: "px-5 py-3 border-b border-gray-300 dark:border-gray-700 flex gap-4 items-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: " font-medium text-gray-700 dark:text-gray-300"
  }, "Assign To"), /*#__PURE__*/React.createElement("div", {
    className: "mr-4 min-w-[200px]"
  }, /*#__PURE__*/React.createElement(DropdownMenu, {
    options: assigneeOptions.map(function (option) {
      return {
        name: option,
        onClick: function onClick() {
          onSelectAssignee(option);
          setAssignee(option);
        }
      };
    }),
    buttonClassName: "w-full text-[12px] text-gray-200 bg-gray-800 border border-gray-700 rounded-md px-4 py-2 flex items-center justify-between",
    hasArrow: true,
    hasCustomControl: true,
    menuItemClassName: "w-[200px] [&>div]:px-4 [&>div]:py-2 text-[12px]",
    Icon: function Icon() {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex items-center gap-2"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-gray-200"
      }, assignee || "Select assignee"));
    }
    // disabled={isBulkTaggingInProgress}
  }))), /*#__PURE__*/React.createElement("div", {
    className: "px-5 py-4"
  }, fieldSelections && fieldSelections.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap gap-2"
  }, fieldSelections.map(function (selection) {
    return /*#__PURE__*/React.createElement(AiTagItem, {
      key: selection.field.uuid,
      field: selection.field,
      value: (editingTag === null || editingTag === void 0 ? void 0 : editingTag.field.id) === selection.field.id ? editedValue : selection.value,
      isEditing: (editingTag === null || editingTag === void 0 ? void 0 : editingTag.field.id) === selection.field.id,
      onEdit: function onEdit() {
        return _onEdit(selection);
      },
      onSave: function onSave() {
        return _onSave(selection);
      },
      onCancel: function onCancel() {
        return _onCancel(selection);
      },
      onValueChange: function onValueChange(value) {
        return _onValueChange(selection, value);
      },
      onRemove: function onRemove() {
        return _onRemove(selection);
      },
      disableEditing: false
    });
  }))), /*#__PURE__*/React.createElement("div", {
    className: "px-5 pb-5"
  }, /*#__PURE__*/React.createElement("button", {
    className: "bg-teal-500 hover:bg-teal-600 text-white font-semibold px-4 py-2 rounded-md transition-all w-full",
    onClick: function onClick() {
      saveAllTags(fieldSelections, assignee);
      setIsDisabled(true);
    }
  }, "Update All Fields"))));
};
export default AddBulkTagging;